import {
  ConversationModelV2,
  ConversationParticipantModelV2,
  ConversationType,
} from "@types";
import { concatNotNull } from "./string-utils";

export const getConversationName = (
  conversation: ConversationModelV2,
  currentUserId: string
): string => {
  if (conversation.type !== ConversationType.Chat) return conversation.name;

  const otherParticipant = conversation.participants.find(
    (p) => p.userId !== currentUserId
  );

  if (!otherParticipant) throw new Error("Missing other participant");

  const conversationName = concatNotNull([
    otherParticipant.firstName,
    otherParticipant.lastName,
  ]);

  return conversationName;
};

export const getParticipantFullName = (
  participant: ConversationParticipantModelV2
): string => {
  return `${participant.firstName} ${participant.lastName}`;
};

const pdfExportableTypes = new Set<string>([
  ConversationType.Case,
  ConversationType.Group,
]);

/** Whether the conversation details panel offers "Export to PDF" for this type. */
export const isPdfExportableConversationType = (
  type: ConversationType | string | null | undefined
): boolean => !!type && pdfExportableTypes.has(type);

/** Snackbar text shown when an export this client requested has finished. */
export const getPdfExportedMessage = (
  type: ConversationType | string | null | undefined
): string => {
  const label =
    type === ConversationType.Case
      ? "Case"
      : type === ConversationType.Group
      ? "Group"
      : "Conversation";
  return `${label} exported! Your download will begin shortly...`;
};
